<template>
  <div :id="brainsSingleSliderContainer" class="brains-single-slider-container">
    <input :id="brainsSingleSliderId" v-model="actualValue" type="range" :step="step" :min="min" :max="max" class="slider not-close-clickable-elements">
    <output v-if="!clear" :value="actualValue" class="range-slider-tooltip range-slider-tooltip-top">{{ actualValue }} {{ unit }}</output>

    <span v-if="!clear">
      <div class="marker bottom-marker marker-0">{{ scale_slider[0] }} {{ unit }}</div>
      <div class="marker bottom-marker marker-25">{{ scale_slider[1] }} {{ unit }}</div>
      <div class="marker bottom-marker marker-50">{{ scale_slider[2] }} {{ unit }}</div>
      <div class="marker bottom-marker marker-75">{{ scale_slider[3] }} {{ unit }}</div>
      <div class="marker bottom-marker marker-100">{{ scale_slider[4] }} {{ unit }}</div>
    </span>
  </div>
</template>

<script>
export default {
  name: 'SingleRangeSlider',
  props: {
    value: {
      type: Number,
      default: 15
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    unit: {
      type: String,
      default: ''
    },
    clear: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      actualValue: this.value,
      randomNum: 0,
      scale_slider: []
    }
  },
  computed: {
    brainsSingleSliderId() {
      return 'brains-single-slider-' + this.randomNum
    },
    brainsSingleSliderContainer() {
      return 'brains-single-slider-container-' + this.randomNum
    }
  },
  watch: {
    value() {
      this.actualValue = this.value
    },
    actualValue(newOne) {
      this.resizeTooltip()
      this.$emit('input', parseInt(newOne))
      this.addProgressStyles()
    },
    max() {
      setTimeout(() => {
        document.getElementById(this.brainsSingleSliderId).click()
      }, 300)
    }
  },
  created() {
    this.generateRandomNum()
  },
  mounted() {
    this.resizeTooltip()
    this.calculateRanges(true)
    this.addProgressStyles()
  },
  methods: {
    calculateRanges(resize) {
      const diff_bottom = this.max - this.min

      this.scale_slider = []
      for (let i = 0; i <= 1; i = i + 0.25) {
        this.scale_slider.push(Math.round(diff_bottom * i + this.min))
      }
      if (resize) {
        setTimeout(() => {
          this.resizeTooltip()
        }, 400)
      }
    },
    getSpanStyle(n) {
      return 'left:' + n + '%'
    },
    resizeTooltip() {
      var percentage = (this.actualValue / this.max) * 100

      if (document.getElementById(this.brainsSingleSliderId) === null) {
        return
      }

      if (document.querySelector('#' + this.brainsSingleSliderContainer + ' .range-slider-tooltip-top') === null) return

      document.querySelector('#' + this.brainsSingleSliderContainer + ' .range-slider-tooltip-top').style.left = 'calc(' + percentage + '% - 10px )'
      document.getElementById(this.brainsSingleSliderId).click()
    },
    generateRandomNum() {
      this.randomNum = Math.floor(Math.random() * (9999 - 0)) + 0
    },
    addProgressStyles() {
      const inputElements = document.querySelectorAll('#' + this.brainsSingleSliderId)
      const handleInput = (inputElement) => {
        let isChanging = false

        const setCSSProperty = () => {
          const percent = ((inputElement.value - inputElement.min) / (inputElement.max - inputElement.min)) * 100
          // Here comes the magic
          inputElement.style.setProperty('--webkitProgressPercent', `${percent}%`)
        }

        // Set event listeners
        const handleMove = () => {
          if (!isChanging) return
          setCSSProperty()
        }
        const handleUpAndLeave = () => (isChanging = false)
        const handleDown = () => (isChanging = true)

        inputElement.addEventListener('mousemove', handleMove)
        inputElement.addEventListener('mousedown', handleDown)
        inputElement.addEventListener('mouseup', handleUpAndLeave)
        inputElement.addEventListener('mouseleave', handleUpAndLeave)
        inputElement.addEventListener('click', setCSSProperty)

        // Init input
        setCSSProperty()
      }

      inputElements.forEach(handleInput)

      setTimeout(() => {
        document.getElementById(this.brainsSingleSliderId).click()
      }, 300)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.brains-single-slider-container {
  width: 100%;
  position: relative;

  .slider {
    width: 100%;
  }

  /*Chrome*/
  @media screen and (-webkit-min-device-pixel-ratio: 0) {
    .slider[type="range"] {
      -webkit-appearance: none;
      background-color: #d2d2d2;
      z-index: 99;
      position: relative;

      --webkitProgressPercent: 0%;
      --thumbSize: 18px;
      --trackSize: 8px;
      --thumbBg: #fff;
      --trackBg: #f2f2f2;
      --progressBg: #1e3cff;
    }

    .slider[type="range"]:focus {
      outline: none;
    }

    .slider[type="range"]::-webkit-slider-runnable-track {
      width: 100%;
      height: 6px;
      background-image: linear-gradient(90deg, var(--progressBg) var(--webkitProgressPercent), var(--trackBg) var(--webkitProgressPercent));
    }

    .slider[type="range"]::-webkit-slider-thumb {
      width: 20px;
      height: 20px;
      border-radius: 50px;
      border: 3px solid $primary-brains;
      -webkit-appearance: none;
      cursor: pointer;
      margin-top: -6px;
      background: white;
      z-index: 9999;
    }

    .slider[type="range"]:focus::-webkit-slider-runnable-track {
      background-image: linear-gradient(90deg, var(--progressBg) var(--webkitProgressPercent), var(--trackBg) var(--webkitProgressPercent));
    }
  }
  /** FF*/
  .slider[type="range"]::-moz-range-progress {
    background-color: $primary-brains;
  }
  .slider[type="range"]::-moz-range-track {
    background-color: #e1e4e9;
  }
  /* IE*/
  .slider[type="range"]::-ms-fill-lower {
    background-color: $primary-brains;
  }
  .slider[type="range"]::-ms-fill-upper {
    background-color: #e1e4e9;
  }

  // Tooltip styles
  .range-slider-tooltip {
    position: absolute;
    font-size: 12px;
    width: 60px;
    border-radius: 4px;
    text-shadow: none;
    color: #333333;
    font-family: "Montserrat-SemiBold",sans-serif;
    display: flex;
    justify-content: flex-start;

    &.range-slider-tooltip-top {
      top: -17px;
    }
  }

  /**
    * MARKERS
   */

  .marker {
    position: absolute;
    font-size: 9px;
    color: rgb(194, 194, 194);
    transform: translateX(-50%);
    z-index: 0 !important;

    &.bottom-marker {
      top: 55%;
      padding-top: 14px;

      &:after {
        top: -5px;
      }
    }

    &:after {
      content: "";
      width: 3px;
      height: 15px;
      background: #f2f2f2;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .marker-0 {
    left: 1.3%;
  }

  .marker-25 {
    left: 25.65%;
  }

  .marker-50 {
    left: 50%;
  }

  .marker-75 {
    left: 74.35%;
  }

  .marker-100 {
    right: 1.3%;
    transform: translateX(50%);
  }
}
</style>
